// extracted by mini-css-extract-plugin
export default {"mainWrapper":"Section4_mainWrapper__YvrJd","subWrapper":"Section4_subWrapper__6BCLp","image":"Section4_image__hzhhC"};